import {
  enableProdMode,
  importProvidersFrom,
  provideAppInitializer,
} from '@angular/core';
import { environment } from './environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RequestInterceptor } from './app/core_modules/auth-interceptor/request-interceptor';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { APP_ROUTES } from './app/app-routes';
import { Chart, registerables } from 'chart.js';
import { provideNativeDateAdapter } from '@angular/material/core';
import { Observable } from 'rxjs';

if (environment.production) {
  enableProdMode();
}

Chart.register(...registerables);

bootstrapApplication(AppComponent, {
  providers: [
    // 1. Routing
    provideRouter(
      APP_ROUTES,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'top',
      }),
    ),

    // 2. HTTP & Interceptors
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },

    // 3. Animations & Toastr
    provideAnimations(),
    importProvidersFrom(
      ToastrModule.forRoot({ preventDuplicates: true }),
      NgxMaskModule.forRoot(),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
        registrationStrategy: 'registerWhenStable:30000',
      }),
    ),

    // 4. Material Date Adapter
    provideNativeDateAdapter(),

    // 5. Pre Application Initialization Configuration Setup
    provideAppInitializer(initializeApplicationConfig()),
  ],
}).catch((err) => console.error(err));

function initializeApplicationConfig(): () => Promise<void> {
  return async () => {
    await Promise.all([initializeWindow()]);
  };
}

async function initializeWindow(): Promise<void> {}
